import { cloneDeep, get, isEmpty, isString } from 'lodash'

export default {
  computed: {
    showButtonContainer() {
      return !this.isSqlChosen && this.isAllowedByDefaultEmpty && this.isCollapsed
        ? this.showCollapsedActions
        : this.showFooterButtons || this.showMongoFooterButtons
    },
    isSqlChosen() {
      return this.$get('isSqlChosen')
    },
    isAllowedByDefaultEmpty() {
      return !this.isEmptyDefaultEmpty || (this.isEmptyDefaultEmpty && this.isSearchBarActive)
    },
    isEmptyDefaultEmpty() {
      return this.defaultEmpty && !this.selectedRow
    },
    isCollapsed() {
      return this.$get('isCollapsed')
    },
    showCollapsedActions() {
      return this.hasCollapsedActions && this.visibilityState({ key: 'showCollapsedActions' })
    },
    showFooterButtons() {
      return this.hasFooterButtons && this.visibilityState({ key: 'showFooterButtons' })
    },
    showMongoFooterButtons() {
      return get(this.mongoList, 'displayFooterButtons')
    },
    isSearchBarActive() {
      const searchParams = cloneDeep(this.searchParams)
      delete searchParams.start
      return (
        isEmpty(searchParams) && this.selectedRowsFilter === 'normal' && isEmpty(get(this.universalFilter, 'value', ''))
      )
    },
    defaultEmpty() {
      return this.$get('defaultEmpty')
    },
    selectedRow() {
      return this.$get('selectedRow')
    },
    hasCollapsedActions() {
      return this.collapsedActions && this.collapsedActions.length > 0
    },
    hasFooterButtons() {
      return this.footerButtons && this.footerButtons.length > 0
    },
    visibilityState() {
      return this.$get('visibilityState')
    },
    searchParams() {
      return this.$get('searchParams')
    },
    queryId() {
      return this.$get('queryId')
    },
    selectedRowsFilter() {
      return this.$get('selectedRowsFilter')
    },
    showDetails() {
      return this.$get('showDetails')
    },
    universalFilter() {
      return get(this.$get('universalFilter'), 'value')
    },
    mongoId() {
      return this.$get('mongoId')
    },
    mongoList() {
      return this.$get('mongoList')
    },
    panelId() {
      const _panelId = this.$get('panelId')
      return isString(_panelId) ? _panelId : null
    },
    popupTitle() {
      return this.$get('popupTitle')
    },
    controllerName() {
      return this.$get('controllerName')
    },
    detailView() {
      return this.$get('detailView')
    },
    docMTNList() {
      return this.$get('docMTNList')
    },
    extendedOptions() {
      return this.$get('extendedOptions')
    },
    buttonOverrides() {
      return this.$get('buttonOverrides')
    },
    isInDashboard() {
      return this.$get('isInDashboard')
    },
    isRelationshipList() {
      return this.$get('isRelationshipList')
    },
    footerButtons() {
      return get(this.$get('buttons'), 'footer.items', [])
    },
  },
}
